import React, { useEffect, useState, useRef, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-17_at_13.24.49_3.webp?v=1771338830',
  alt: 'Testimonio de alumna 1'
}, {
  id: 2,
  image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-17_at_13.24.49_1_1.webp?v=1771337758',
  alt: 'Testimonio de alumna 2'
}, {
  id: 3,
  image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-17_at_13.24.48_3.webp?v=1771337149',
  alt: 'Testimonio de alumna 3'
}, {
  id: 4,
  image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-17_at_13.24.48_1_1.webp?v=1771337103',
  alt: 'Testimonio de alumna 4'
}, {
  id: 5,
  image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-17_at_13.24.50_1.webp?v=1771337078',
  alt: 'Testimonio de alumna 5'
}, {
  id: 6,
  image: 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/WhatsApp_Image_2026-02-17_at_13.24.49_2_1.webp?v=1771336817',
  alt: 'Testimonio de alumna 6'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const isVisibleRef = useRef(false);
  const sectionRef = useRef<HTMLElement>(null);
  // Only auto-advance when section is visible on screen
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      isVisibleRef.current = entry.isIntersecting;
    }, {
      threshold: 0.1
    });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      if (isVisibleRef.current) {
        setDirection(1);
        setCurrentIndex(prev => (prev + 1) % testimonials.length);
      }
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  const handleNext = () => {
    setDirection(1);
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  };
  const handlePrev = () => {
    setDirection(-1);
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  const handleDotClick = (index: number) => {
    setDirection(index > currentIndex ? 1 : -1);
    setCurrentIndex(index);
  };
  const slideVariants = {
    enter: (d: number) => ({
      x: d > 0 ? 300 : -300,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (d: number) => ({
      x: d < 0 ? 300 : -300,
      opacity: 0
    })
  };
  return <section ref={sectionRef} className="w-full bg-[var(--bg-dark)] py-8 md:py-12 px-4" data-id="element-293">
      <div className="max-w-5xl mx-auto" data-id="element-294">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-black text-[var(--text-light)] mb-6 md:mb-10 text-center reveal" data-id="element-295">
          Lo que dicen nuestras alumnas:
        </h2>

        <div className="relative" data-id="element-296">
          <div className="relative overflow-hidden rounded-xl shadow-2xl bg-[var(--bg-card)]" style={{
          height: '600px',
          contain: 'strict'
        }} data-id="element-297">
            <AnimatePresence initial={false} custom={direction} data-id="element-298">
              <motion.div key={currentIndex} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
              x: {
                type: 'tween',
                duration: 0.3,
                ease: 'easeInOut'
              },
              opacity: {
                duration: 0.3
              }
            }} className="absolute inset-0 w-full h-full" data-id="element-299">
                <img src={testimonials[currentIndex].image} alt={testimonials[currentIndex].alt} className="w-full h-full object-cover" style={{
                objectPosition: 'top center'
              }} loading="lazy" decoding="async" width={600} height={600} data-id="element-300" />
              </motion.div>
            </AnimatePresence>
          </div>

          <button onClick={handlePrev} className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-[var(--accent-orange)] p-2 md:p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-10" aria-label="Testimonio anterior" data-id="element-301">
            <ChevronLeftIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-302" />
          </button>

          <button onClick={handleNext} className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-[var(--accent-orange)] p-2 md:p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-10" aria-label="Siguiente testimonio" data-id="element-303">
            <ChevronRightIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-304" />
          </button>

          <div className="flex justify-center gap-2 mt-6" data-id="element-305">
            {testimonials.map((_, index) => <button key={index} onClick={() => handleDotClick(index)} className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-300 ${index === currentIndex ? 'bg-[var(--accent-orange)] w-8 md:w-10' : 'bg-[var(--text-gray)]/30 hover:bg-[var(--text-gray)]/50'}`} aria-label={`Ir al testimonio ${index + 1}`} data-id="element-306" />)}
          </div>
        </div>

        <div className="text-center mt-4" data-id="element-307">
          <p className="text-sm md:text-base text-[var(--text-gray)]" data-id="element-308">
            {currentIndex + 1} / {testimonials.length}
          </p>
        </div>
      </div>
    </section>;
}